export function isNotNull<T>(item: T | null | undefined): item is T {
  return item != null;
}

export function assertNotNull<T>(item: T | null | undefined, msg: string = 'Item is null or undefined'): T {
  if (item == null) {
    throw new Error(msg);
  }
  return item;
}
